import { getStrapiMediaUrl } from '@/lib/strapi-media-url';

/**
 * Client-safe original-upload URL selection. The legacy size argument is kept
 * so existing callers do not need to change.
 */
export function getOptimizedImageUrl(
  media: any,
  size: 'thumbnail' | 'small' | 'medium' | 'large' = 'medium',
): string {
  return getStrapiMediaUrl(media, size) ?? '';
}
